import { Component, OnInit, EventEmitter, Output, Input, ViewChild, DoCheck, ElementRef, NgZone, ViewContainerRef, ViewRef, ChangeDetectorRef } from "@angular/core";
import { JobSiteDetailModel } from "src/app/fs-lte/models/customer/job-site-detail-model";
import { ActionName } from "@shared/enums/action-name";
import { PermissionPipe } from "@shared/pipes/permission";
import { TabOpenService } from "src/app/services/tab-open.service";
import { CustomerEditComponent } from "@fs/components/customer/cust-edit/cust-edit.component";
import { CustomerEditType, TabType } from "@fs/enums/common";
import { Tabs } from "src/app/enums/tab.enum";
import { JobsiteCreateComponent } from "@fs/components/customer/jobsite-create/jobsite-create.component";
import { CustomerService } from '@fs/services/customer';
import { GridDataResult, DataStateChangeEvent } from "@progress/kendo-angular-grid";
import { DataSourceRequestState } from "@progress/kendo-data-query";
import { ISubscription } from "rxjs/Subscription";
import { FormGroup, FormBuilder, FormControl, Validators } from "@angular/forms";
import { CommonMethods } from "src/app/services/common.method";
import { KendoUploadFileInfo } from "@fs/components/price-book/material-item/material-create/material-create.component";
import { Attachment } from "@fs/models/price-book/material-item.model";
import { SuccessEvent, RemoveEvent, FileRestrictions, UploadEvent, CancelEvent } from "@progress/kendo-angular-upload";
import { NotificationsService } from "@shared/services/notification";
import { AuthService } from "src/app/services/auth.service";
import { Constants } from "@shared/models/constants";
import { JobSiteRequest } from "@shared/models/jobsite-request.model"
import { EquipmentModel, WarrantyModel } from "@fs/models/equipment.model";
import { WarrantyTypeModel } from "@fs/models/equipment.model";
import { EquipmentDetailEditComponent } from "@fs/components/common/jobsite-equipment/equipment-detail/equipment-detail-edit/equipment-detail-edit.component";
import { EquipmentListComponent } from "@fs/components/common/jobsite-equipment/equipment-list/equipment-list.component";
import { SpinnerService } from "src/app/shared/services/spinner.service";

import { CommonService } from "@shared/services/common";
import { FsUtil } from "@fs/services/fs-utils";
import { Grid } from "@fs/enums/grid.enum";
import { TabParams } from "@fs/services/tab-params.service";
declare var SimpleBar: any;

@Component({
  selector: "app-customer-jobsite-edit",
  templateUrl: "./customer-jobsite-edit.component.html",
  styleUrls: ["./customer-jobsite-edit.component.scss"],
  providers: [CustomerService]
})
export class CustomerJobsiteEditComponent implements OnInit, DoCheck {
  //#region Input/Output
  @Output() openEditCustomerModal = new EventEmitter();
  @ViewChild("customerEdit") customerEdit: CustomerEditComponent;
  @ViewChild("customerJobsiteEdit") customerJobsiteEdit: JobsiteCreateComponent;
  @ViewChild("JobsiteEquipmentEdit") JobsiteEquipmentEdit: EquipmentDetailEditComponent;
  @ViewChild("workOrdersGridSection", {
    read: ViewContainerRef
  }) workOrdersGridSection: ViewContainerRef;
  @ViewChild("workOrdersGridSectiongrid", {
    read: ViewContainerRef
  }) workOrdersGridSectiongrid: ViewContainerRef;
  @ViewChild("DocumentsDiv", {
    read: ViewContainerRef
  }) DocumentsDiv: ViewContainerRef;
  @ViewChild("DocumentsDivgrid", {
    read: ViewContainerRef
  }) DocumentsDivgrid: ViewContainerRef;
  @ViewChild("attachImagePreview") attachImagePreview: ElementRef;
  @ViewChild("attachmentUploadImageBtn") attachmentUploadImageBtn: ElementRef;
  @ViewChild('equipmentList') equipmentListRef: EquipmentListComponent;
  //#endregion

  //#region Variable Declarations
  private inputParams: any;
  private jobSiteSelectorDummyValue = { DisplayName: 'Select another Job Site', ResetName: 'Select another Job Site', ID: CommonMethods.GetID() }
  private defaultSort: any[] = [];
  private prev_state: DataSourceRequestState = {
    skip: 0,
    take: 25,
    sort: this.defaultSort
  };

  private oppositeDefaultSort: any = [{
    field: 'PromisedDate',
    dir: 'asc'
  }];
  private k_grid: any;
  /** Flag is used to check if api hit is required when quickSearch length is 0 */
  private triggerRefresh: boolean = false;

  /**0: Customer Billing, 1: Job Site */
  public activeSubTabIndex: number = 0; // by default first tab selected
  /**previewType : billing or jobsite. Use for inner tab focus */
  public previewType: TabType;
  public showCustomerEditModal: boolean = false;
  public showJobSiteEditModal: boolean = false;
  public showJobsiteEquipmentViewModal: boolean = false;
  public detailData: any;
  public jobSiteDetail: any; //JobSiteDetailModel = new JobSiteDetailModel();
  public isCustomerInEditMode: Boolean = false;
  public isJobSiteInEditMode: boolean = false;
  public primaryContactInfo: any;
  public jobSitePrimaryContactInfo: any;
  public destroyTab: Boolean = false;
  public tabCounter: number;
  public isUnsavedTriggered: boolean = false;
  public customerEditInfo: { customerEditType: CustomerEditType } = {
    customerEditType: CustomerEditType.Billing
  };
  public jobSitesList: any = [];
  public intialData: any;
  public copyJobSiteInfo: any;
  public customerJobSitesOriginal: any;
  public customerJobSites: any;
  /** To clear the selection in job site dropdown */
  public jobSiteSelectionResetVal = this.jobSiteSelectorDummyValue;
  public dataLoaderCount: number = 2;
  public workOrdersGridData: GridDataResult = { data: [], total: 0 };
  public state: DataSourceRequestState = {
    skip: 0,
    take: 25,
    sort: this.defaultSort
  };
  public pageSizes = { pageSizes: [25, 100, 300], refresh: true };
  public searchKey: string = "";
  public listGetSubscription: ISubscription;
  public customFilterForm: FormGroup;
  public showDeleteEquipmentConfirmation = false
  public attachments: GridDataResult = { data: [], total: 0 };
  public showAttachmentSlider: boolean = false;
  public slideIndex: number = 0;

  public kendoUploadFileList: KendoUploadFileInfo[] = [];
  public modalOptions: { showAttachment: boolean } = { showAttachment: false };
  public attachmentType: string = "Image";
  public editAttachmentForm: FormGroup;
  public attachmentForm: FormGroup;
  public isEditAttachment: boolean = false;
  public showDeleteConfirmation: boolean = false;
  public deleteDataItem: any;
  public deleteMessage: string = "";
  public saveUrl: string = "";
  /** update flag when file upload is in progress */
  public isUploadInProgress = true;
  public qbVersion: string;
  public originalJobSite: any;
  public selectedJobSite: any;
  public actionName = ActionName;
  public hasWorkOrderManagePermission: boolean = true;
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: Constants.DefaultFileExtension,
    maxFileSize: Constants.DefaultFileSize.inbytes
  };
  public allowedextensionsforAttachment: string = '';
  public allowedsizeforAttachment: number = 0;
  public emptyGuid;
  public showJobsiteViewEquipment: boolean = false;
  public EquipmentId: string;
  public dsEquipmentDetail: EquipmentModel = new EquipmentModel();
  public duplicateEquipment: boolean = false;
  public showNewEquipmentModal: boolean = false;
  public showEqHistoryModal: boolean = false;
  public companyData: any;
  public customerAddress: string;
  public jobSiteAddress: string;
  public showNoRecord: boolean = false;
  public showNoRecordworkorder: boolean = false;
  private subscriptions: ISubscription[] = [];
  loadAgreement: boolean = false;
  loadEquipment: boolean = false;
  loadWorkOrder: boolean = false;
  loadAttachment: boolean = false;
  loadEstimate: boolean = false;
  cancelSettings = { ID: null, show: false };
  postponementSettings = { ID: null, show: false };
  updateVisitSettings = { update: false, type: '', data: null };
  //#endregion

  //#region Constructor
  constructor(
    private permissionPipe: PermissionPipe,
    private tabOpen: TabOpenService,
    private httpCustomerService: CustomerService,
    private frmbuilder: FormBuilder,
    private zone: NgZone,
    private _elementRef: ElementRef,
    private commonMethods: CommonMethods,
    private toastr: NotificationsService,
    private authService: AuthService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private httpCommon: CommonService,
    private changeDetector: ChangeDetectorRef,
  ) {

    this.IntializeFilters();
    FsUtil.configSort(this.defaultSort, Grid.JobSiteWorkOrder)
    this.tabOpen.TabOpenEvent.subscribe(response => {
      if (!CommonMethods.CheckNullOrUndefined(response, false)) {
        if (response["params"] != undefined && response["params"] != null && response["params"]["previewType"] != null) {
          this.previewType =
            response["params"]["previewType"].toLowerCase() == "billing"
              ? TabType.CustomerBilling
              : TabType.JobSite;
          this.SetTabFocus(this.previewType);
        }
        this.jobSiteSelectionResetVal = this.jobSiteSelectorDummyValue;
      }
    });

    this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        if (this.customerEdit != undefined) {
          this.destroyTab = true;
          setTimeout(() => {
            this.customerEdit.SaveCustomerDetail()
          }, 100);
        }
      }
    });

    this.tabOpen.destroyModalEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter && response.event == "destroy") {
        if (this.customerEdit != undefined) {
          this.showCustomerEditModal = false;
          this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
          this.isUnsavedTriggered = false;

        }
      }
      else if (response.tabCounter == this.tabCounter && response.event == "save") {
        if (this.customerEdit != undefined) {
          setTimeout(() => {
            this.customerEdit.SaveCustomerDetail()
            this.tabOpen.unsavedChangedDetected({ dirty: false, Index: this.tabCounter });
            this.isUnsavedTriggered = false;
          }, 100)
        }
      }
    });
    this.qbVersion = (this.authService.getCompanyQBType()).toLowerCase(); //QBDesktop,QBOnline,None

    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(this.uploadRestrictions.allowedExtensions);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;
    this.emptyGuid = CommonMethods.GetID();

    this.warrantytypemodel = {
      Name: "Service Only", Description: "Cover only service",
      DurationType: {
        ID: "AC3B024D-0208-4DD7-BC46-A9F900F976B5", Code: "yearly", Name: "Yearly"
      },
      DurationValue: 1,
      IsLifeTime: true,
      IsActive: true,
      UsedIn: null,
      ID: "AC3B024D-0208-4DD7-BC46-A9F900F976B5"
    };

    //#region To trigger popup scroll to auto adjust popup
    this.subscriptions.push(this.tabOpen.focusTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {// on tab focus
        this.commonMethods.resetPageScroll();
      }
    }));
    //#endregion
  }
  //#endregion
  //#region Lifecycle Events
  ngOnInit() {
    this.GetCustomerData();
  }
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      if (this.customerEdit != undefined && this.customerEdit.customerEditForm != undefined && this.customerEdit.customerEditForm != null) {
        let isDirty = this.customerEdit.customerEditForm.dirty;
        if (isDirty) {
          this.isUnsavedTriggered = true;
          this.tabOpen.unsavedChangedDetected({
            dirty: isDirty,
            Index: this.tabCounter
          });
        }
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  //#endregion

  //#region Methods

  public GetInitialData() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let subscription = this.httpCommon
      .GetIntialData(
        this.authService.getCompanyId(),
        "equipmentwarrantytype,equipmentmanufacturers,equipmentcategories"
      )
      .subscribe(response => {
        this.companyData = response;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      }, (error: any) => { this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter); }); 
    this.subscriptions.push(subscription);
  }

  public OnTabSelect(data) {
    this.activeSubTabIndex = data["index"];
  }

  public JobSiteSelectionChange(value: any, ref: any): void {
    if (value.ID != undefined && value.ID != CommonMethods.GetID()) {
      // this.jobSiteSelectionResetVal = this.jobSiteSelectorDummyValue;
      //  ref.reset();
      this.selectedJobSite = this.originalJobSite;
      let objCustomer = this.detailData;
      objCustomer.JobSites = [];
      this.tabOpen.OpenTab({
        tabId: Tabs.FsLiteCustomerJobSiteEdit,
        params: {
          ID: value.ID,
          jobsiteId: value.ID,
          objDetailData: objCustomer,
          previewType: "JobSite"
        },
        tabTitle: `Job Site - ${value.DisplayName}`,
        replaceIfOpen: {
          replaceTab: true,
          tabToReplace: Tabs.FsLiteCustomerJobSiteEdit,
          action: "focus"
        }
      });

    }

  }
  public JobsiteDropdownBlur(value: any) {
    this.selectedJobSite = this.originalJobSite;
  }
  private OpenEditCustomer() {
    this.showCustomerEditModal = true;
  }

  private OpenEditJobsite() {
    //set currently selected job site id
    this.showJobSiteEditModal = true;
  }

  public Edit() {
    if (this.customerJobSites.length > 1) {
      if (this.activeSubTabIndex == TabType.CustomerBilling) {
        this.OpenEditCustomer();
      }
      else {
        this.OpenEditJobsite();
      }
    }
    else {
      this.customerEditInfo = undefined;
      this.OpenEditCustomer();
    }
  }

  public SetTabFocus(previewType: TabType) {
    if (!this.isCustomerInEditMode || !this.isJobSiteInEditMode)
      this.activeSubTabIndex = previewType;
  }

  public CloseEditCustomer(data: any) {
    if (data) {
      if (typeof data == "boolean") {
        if (data) this.tabOpen.DestroyTab(this.tabCounter, "modal");
        else this.showCustomerEditModal = false;
      } else {
        this.customerEdit = undefined;
        this.detailData = Object.assign({}, data);
        if (!CommonMethods.CheckNullOrUndefined(this.jobSiteDetail)) {
          let selectedJobSiteDetail = data.JobSites.find(x => x.ID == this.jobSiteDetail.ID);
          this.jobSiteDetail = (!CommonMethods.CheckNullOrUndefined(selectedJobSiteDetail)) ? selectedJobSiteDetail : new JobSiteDetailModel;
        }
        else
          this.jobSiteDetail = new JobSiteDetailModel;
        if (!CommonMethods.CheckNullOrUndefined(this.jobSiteDetail.Contacts, true))
          this.jobSitePrimaryContactInfo = this.jobSiteDetail.Contacts.find(x => x.Contact.IsPrimary).Contact;
        else
          this.jobSitePrimaryContactInfo = "";

        if (!CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true))
          this.primaryContactInfo = this.detailData.Contacts.find(x => x.Contact.IsPrimary == true).Contact;
        else
          this.primaryContactInfo = "";

        if (!CommonMethods.CheckNullOrUndefined(this.detailData)) {
          this.customerAddress = CommonMethods.GetCompleteAddress(this.detailData);
        }

        this.showCustomerEditModal = false;
        this.tabOpen.unsavedChangedDetected({
          dirty: false,
          Index: this.tabCounter
        });
        this.isUnsavedTriggered = false;
      }
    } else this.showCustomerEditModal = false;
  }

  public CloseEditJobSite(data: any) {
    if (data != undefined) {
      if (typeof data == "boolean") {
        if (data) this.tabOpen.DestroyTab(this.tabCounter, "modal");
        else this.showJobSiteEditModal = false;
      } else {
        this.customerEdit = undefined;
        this.detailData = Object.assign({}, data);
        this.showJobSiteEditModal = false;
        this.tabOpen.unsavedChangedDetected({
          dirty: false,
          Index: this.tabCounter
        });
        this.isUnsavedTriggered = false;
      }
    } else this.showJobSiteEditModal = false;
  }

  public updatejobsiteData(data: any) {
    if (data) {
      let result = Object.assign({}, data.Customer);
      data.Customer = null;
      result.JobSites = [Object.assign({}, data)];
      this.detailData = result;
      this.jobSiteDetail = data;
      if (!CommonMethods.CheckNullOrUndefined(this.jobSiteDetail)) {
        this.jobSiteAddress = CommonMethods.GetCompleteAddress(this.jobSiteDetail)
      }
      let primaryContact = this.jobSiteDetail.Contacts.find(x => x.Contact.IsPrimary);
      this.jobSitePrimaryContactInfo = !CommonMethods.CheckNullOrUndefined(primaryContact.Contact) ? primaryContact.Contact : null;
      let jobSiteIndex = this.customerJobSites.findIndex(({ ID }) => ID === data.ID);
      this.customerJobSites.splice(jobSiteIndex, 1);
      this.customerJobSites.splice(jobSiteIndex, 0, data);
      this.customerJobSitesOriginal = this.customerJobSites;
      this.tabOpen.updateTabName({ tabTitle: `JobSite - ${data.DisplayName}`, Index: this.tabCounter });
      this.CloseEditJobSite(false);
    }
  }

  public CreateNewJobSite() {
    this.tabOpen.OpenTab(
      {
        tabId: Tabs.NewJobSite,
        params: {
          ID: this.detailData.ID,
          DetailData: this.detailData
        },
        tabTitle: 'New Job Site -' + this.detailData.DisplayName
      }
    )
  }

  public ViewWorkOrder(dataItem) {
    this.tabOpen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderView,
      params: {
        ID: dataItem.ID,
        jobsiteId: this.inputParams.jobsiteId,
        customerId: this.detailData.ID
      },
      tabTitle: dataItem.WorkTicketNo == null ? " " : dataItem.WorkTicketNo,
      replaceIfOpen: {
        replaceTab: true,
        tabToReplace: Tabs.FsLiteWorkOrderEdit,
        action: "focus"
      }
    });
  }

  public RefreshGrid(event = null) {
    if (event != null) event.preventDefault();
    this.GetJobSiteWorkOrders(0);
  }

  public DataStateChange(state: DataStateChangeEvent): void {
    state.sort = state.sort != null ? (state.sort[0].dir == undefined ? (state.sort[0].field != "PromisedDate" ? this.defaultSort : this.oppositeDefaultSort) : state.sort) : null;
    this.state = state;
    this.GetJobSiteWorkOrders();
  }

  public QuickSearch() {
    let searchString = this.customFilterForm.controls["searchString"].value;
    if (searchString.trim() == "" && this.triggerRefresh) {
      this.searchKey = searchString;
      this.resetState();
      this.GetJobSiteWorkOrders();
    } else {
      this.searchKey = searchString.toUpperCase();
      if (searchString.length > 2) { 
        this.resetState();
        this.GetJobSiteWorkOrders();
      }
    }
  }

  public ClearQuickSearch() {
    this.customFilterForm.controls["searchString"].patchValue("");
    this.searchKey = "";
    this.resetState();
    this.GetJobSiteWorkOrders();
  }

  public CreateNewWorkOrder(e) {
    e.stopPropagation();
    this.tabOpen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderCreate,
      params: { data: this.detailData },
      tabTitle: "New Work Order"
    });
  }

  public ReIntializeScroll() {
    this.zone.runOutsideAngular(() => {
      this.k_grid = new SimpleBar(
        $(this._elementRef.nativeElement).find(".k-grid-aria-root")[0],
        { autoHide: false }
      );
    });
  }
  public handleJobSiteFilter(value) {
    this.customerJobSites = this.customerJobSitesOriginal.filter(
      s =>
        `${s.DisplayName} ${s.Unit} ${s.StreetNo} ${s.City} ${s.State} ${s.ZipCode}`
          .toLowerCase()
          .indexOf(value.toLowerCase()) !== -1
    );
  }

    public GetCustomerData(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
      this.GetInitialData();
      if (this.inputParams != undefined && this.inputParams != null) {
        this.previewType = this.inputParams.previewType.toLowerCase() == "billing" ? TabType.CustomerBilling : TabType.JobSite;
        this.SetTabFocus(this.previewType);
        this.detailData = Object.assign({}, this.inputParams.objDetailData);
        this.saveUrl = this.httpCustomerService.GetAttachmentURL(this.detailData.ID, this.inputParams.jobsiteId);
        this.LoadViewData(instantSpinnerTime);
      }
      window.addEventListener('scroll', this.scroll, true); //third parameter

      this.hasWorkOrderManagePermission = this.permissionPipe.transform(ActionName.ManageWorkOrders);
  }

  private IntializeEditAttachment(item = null) {
    if (!CommonMethods.CheckNullOrUndefined(item)) {
      this.attachmentType = item.IsImage;
      this.editAttachmentForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        Description: new FormControl(item.Description),
        ImagePath: new FormControl(item.FilePath),
        FileName: new FormControl(item.FileName),
        IsImage: new FormControl(item.IsImage),
        Uid: new FormControl(item.Uid)
      });

      if (item.FilePath != "" && item.FilePath != null) {
        setTimeout(() => {
          if (item.IsImage)
            $(this.attachImagePreview.nativeElement).show();
        }, 100);
      }
    }
  }

  public OpenEdit(e, dataItem) {
    if (dataItem.HasWorkOrderAttachments) {
      e.stopPropagation();
      return;
    }

    this.IntializeEditAttachment(dataItem);
    this.isEditAttachment = true;
  }

  public Delete(e, dataItem) {
    if (dataItem.HasWorkOrderAttachments) {
      e.stopPropagation();
      return;
    }

    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    if (this.attachments.data.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.deleteMessage = "This action will permanently delete the record.";
    }
  }

  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    if (ref) {
      let dataItem = this.deleteDataItem;
      if (!CommonMethods.CheckNullOrUndefined(dataItem.ID)) {
        this.ManageJobSiteAttachments(2, dataItem);
      }
    } else {
      this.deleteDataItem = null;
    }
  }

  public RemovePreview(
    type,
    ImageFileControl1,
    ImageFileControl2,
    DragAndDropImage,
    UploadImageBtn,
    ImagePreview,
    DeletePreview
  ) {
    $(ImageFileControl1).val("");
    $(ImageFileControl2).val("");
    this.editAttachmentForm.controls["ImagePath"].patchValue("");

    //$(ImagePreview).attr('src', '');
    $(DeletePreview).hide();
    $(ImagePreview).hide();
    $(DragAndDropImage).show();
    $(UploadImageBtn).hide();
  }

  public ChangeAttachmentType(value) {
    this.attachmentType = value;
  }

  public OpenAttachment(e) {
    e.stopPropagation();
    this.kendoUploadFileList = [];
    this.modalOptions.showAttachment = true;
    this.attachmentType = "File";
    this.IntializeAttachmentForm();
  }

  public CloseModal(type) {
    if (type == "Attachment") {
      if (this.attachmentForm.dirty) {
        //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
        this.modalOptions.showAttachment = false;
      } else {
        this.modalOptions.showAttachment = false;
      }
    }
    if ((type == "EditAttachment")) {
      //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
      this.isEditAttachment = false;
    }
    if (type == "ViewJobsiteEquipment") {
      this.showJobsiteEquipmentViewModal = false;
    }
  }

  public UploadEventHandler(e: UploadEvent) {
    this.isUploadInProgress = true;
  }
  public CompleteEventHandler(e: CancelEvent) {
    this.isUploadInProgress = false;
  }
  public RemoveEventHandler(e: RemoveEvent) {
    const index = this.kendoUploadFileList.indexOf(
      this.kendoUploadFileList.find(x => x.fileInfo.uid == e.files[0].uid)
    );
    if (index > -1) {
      this.kendoUploadFileList.splice(index, 1);
    }
  }

  public SuccessEventHandler(e: SuccessEvent) {
    if (e.operation == "upload") {
      let fileInfo = e.response.body[0];
      var info = new KendoUploadFileInfo();

      info.fileInfo = e.files[0];
      info.attachmentInfo = new Attachment();
      info.attachmentInfo.FileName = e.files[0]["name"];
      info.attachmentInfo.FilePath = fileInfo.StorageLocation;
      if (this.kendoUploadFileList.length > 0 && this.kendoUploadFileList.find(x => x.attachmentInfo.FileName == info.attachmentInfo.FileName) != undefined) {
        e.preventDefault();
        this.toastr.error(
          "This file has already been attached, Please rename and try again."
        );
      }
      else {
        this.kendoUploadFileList.push(info);
      }
    }
  }

  public ErrorEventHandler(e: any) {
    if (e.response != null) {
      this.toastr.showMultiLineError(e.response.error.Message, "Error");
    } else {
      this.toastr.showMultiLineError("Something went wrong!", "Error");
    }
  }

  public async AddAttachment() {
    /* New attachment */
    if (this.attachmentType == "File") {
      this.ManageJobSiteAttachments(0, "");
      this.CloseModal("Attachment");
    }
  }

  public RemoveDocument(dataItem) {
    if (dataItem.ID == null || dataItem.ID == "") {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.Uid == dataItem.Uid),
        1
      );
    } else {
      this.attachments.data.splice(
        this.attachments.data.findIndex(x => x.ID == dataItem.ID),
        1
      );
    }
  }

  OpenWorkOrder(workOrderId, WorkTicketNo) {
    if (CommonMethods.CheckNullOrUndefined(workOrderId) || CommonMethods.CheckNullOrUndefined(WorkTicketNo) || !this.hasWorkOrderManagePermission || WorkTicketNo.length <= 1) { // '1' length check is there for '-' no work order
      return;
    }
    let params = {
      ID: workOrderId,
      customerId: this.detailData.ID,
      jobsiteId: this.inputParams.jobsiteId
    }
    this.tabOpen.OpenTab({
      tabId: Tabs.FsLiteWorkOrderView,
      params: params,
      tabTitle: WorkTicketNo
    })
  }

  public async EditDocument() {
    let currentID = this.editAttachmentForm.controls["ID"].value;
    let updatedDescription = this.editAttachmentForm.controls["Description"].value;
    if (this.attachments.data.find(x => currentID != null && currentID != "" && x.ID == currentID) != undefined) {
      var idx = this.attachments.data.findIndex(x => (currentID != null && currentID != "" && x.ID == currentID)
        || ((currentID == null || currentID == "")));
      const exisitingItem = Object.assign([], this.attachments.data[idx]);
      if (exisitingItem["Description"] != updatedDescription && !CommonMethods.CheckNullOrUndefined(updatedDescription)) {
        exisitingItem["Description"] = updatedDescription;
        exisitingItem["IsDirty"] = true;
        this.ManageJobSiteAttachments(1, exisitingItem);
      }
    }
    this.CloseModal("EditAttachment");
  }

  //#region Jobiste Equipment  
  public OpenEquipmentDetail(val: string) {
    /* Call Equipment detail api here to fetch data */
    this.EquipmentId = val;
    this.showJobsiteEquipmentViewModal = true;
  }

  public openNewEquipment(e) {
    e.stopPropagation();
    this.EquipmentId = undefined;
    this.duplicateEquipment = false;
    this.dsEquipmentDetail = undefined;
    this.showNewEquipmentModal = true;
  }

  public OpenEditEquipment(val: any) {
    this.showNewEquipmentModal = true;
    this.duplicateEquipment = false;
    this.dsEquipmentDetail = null;
    this.showJobsiteEquipmentViewModal = false;
    if (typeof (val) == "string")
      this.EquipmentId = val;
    else
      this.dsEquipmentDetail = val
  }

  public openDuplicateEquipment(val: any) {
    this.showNewEquipmentModal = true;
    this.showJobsiteEquipmentViewModal = false;
    this.duplicateEquipment = true;
    this.dsEquipmentDetail = null;
    if (typeof (val) == "string")
      this.EquipmentId = val;
    else
      this.dsEquipmentDetail = val
  }

  public CloseEquipmentEditModal(savedData: any) {
    this.showJobsiteEquipmentViewModal = false;
    this.showNewEquipmentModal = false;
    if (!CommonMethods.CheckNullOrUndefined(savedData)) {
      if (savedData.RefreshRequired) {
        this.equipmentListRef.RefreshGrid();
      }
    }
  }

  public CloseViewEquipment() {
    this.showJobsiteEquipmentViewModal = false;
  }

  public closeNewEquipmentModal(savedData: any) {

    if (!CommonMethods.CheckNullOrUndefined(savedData)) {
      if (typeof savedData.Result == "boolean") {
        if (savedData.Result)
          this.tabOpen.DestroyTab(this.tabCounter, "modal");
        else
          this.showNewEquipmentModal = false;
      } else {
        this.showNewEquipmentModal = false;
        this.tabOpen.unsavedChangedDetected({
          dirty: false,
          Index: this.tabCounter
        });
        this.isUnsavedTriggered = false;
      }
    } else this.showNewEquipmentModal = false;

    if (!CommonMethods.CheckNullOrUndefined(savedData)) {
      if (savedData.RefreshRequired) {
        this.equipmentListRef.RefreshGrid();
      }
    }
  }

  public DeleteEquipment() {
    this.showDeleteEquipmentConfirmation = true;
  }

  public ConfirmDeleteEquipment() {
    this.showDeleteEquipmentConfirmation = false;
    this.equipmentListRef.deleteEquipment();
  }
  public CancelDeleteEquipment() {
    this.showDeleteEquipmentConfirmation = false;
  }

  public updateEquipmentData() {

  }

  public ShowEquipmentHistory(data) {
    if (!CommonMethods.CheckNullOrUndefined(data, false)) {
      this.dsEquipmentDetail = data.equipmentData;
    }
    setTimeout(() => {
      this.showEqHistoryModal = true;
    }, 100);
  }

  public CloseEqHistoryModal() {
    this.showEqHistoryModal = false;
  }

  public ChangeBLoaderState(eventData) {
      if (!CommonMethods.CheckNullOrUndefined(eventData, false)) {
      if(eventData.showloader)
      {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      }
      else
      {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      }
    }
  }

  loadWorkOrders() {
    if (!this.loadWorkOrder) {
      this.loadWorkOrder = true;
      this.GetJobSiteWorkOrders();
    }
  }
  
  loadAttachments() {
    if (!this.loadAttachment) {
      this.loadAttachment = true;
      this.GetJobSiteAttachments();
    }
  }
  
  loadEquipments() {
    if (!this.loadEquipment) {
      this.loadEquipment = true;
      this.changeDetector.detectChanges();
    }
  }
  
  loadAgreements() {
    if (!this.loadAgreement) {
      this.loadAgreement = true;
      this.changeDetector.detectChanges();
    }
  }

  loadEstimates() {
    if (!this.loadEstimate) {
      this.loadEstimate = true;
      this.changeDetector.detectChanges();
    }
  }

  cancelVisit(e) {
    this.cancelSettings = { ID: e.ID, show: e.show };
  }
  
  onCancelVisitChange(e) {
    if (e.loader)
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
    else 
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    
    if (e.dataUpdate) {
      this.updateVisitSettings = { update: true, data: { ID : this.cancelSettings.ID }, type: 'cancel' };
      this.cancelSettings.ID = null;
    }
    else {
      this.updateVisitSettings = { update: false, data: null, type: 'cancel' };
    }
    this.cancelSettings.show = false;
  }

  postponeVisit(id) {
    this.postponementSettings = { ID: id, show: true };
    this.updateVisitSettings = { update: false, data: null, type: 'postponement' };
  }

  closePostponement(e) {
    this.postponementSettings = { ID: null, show: false };
    if (e)
      this.updateVisitSettings = { update: true, data: Object.assign(e), type: 'postponement' };
  }

  createNewEstimate(e = null) {
    if (e) {
      e.stopPropagation();
    }
    this.tabOpen.OpenTab(TabParams.NewEstimate({ Customer: this.detailData, JobSite: this.jobSiteDetail }));
  }
  //#endregion

  public warrantytypemodel: WarrantyTypeModel;

  public warranties: WarrantyModel[] = [];

  private IntializeAttachmentForm(item = null) {
    if (item != null) {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        Uid: new FormControl(item.Uid),
        FileName: new FormControl(item.FileName, [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        Description: new FormControl("", Validators.maxLength(1024)),
        ImagePath: new FormControl(item.FilePath == null ? "" : item.FilePath)
      });
    } else {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(""),
        FileName: new FormControl("", [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        ImagePath: new FormControl(""),
        Description: new FormControl("", Validators.maxLength(1024))
      });
    }
  }

  private LoadViewData(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.GetCustomerJobsites(instantSpinnerTime);
    this.GetDetails(instantSpinnerTime);
  }
  private updateJobSiteDocumentsAndImages(x: any, type: number, request: any) { // 0 new, 1 edit, 2 delete    
    if (x != null) {
      let newAttachmentList = Object.assign([], this.attachments.data);
      if (type == 2) {
        let indexOfOldAttachment = newAttachmentList.findIndex(elem => elem.ID == request[0].ID);
        if (indexOfOldAttachment >= 0)
          newAttachmentList.splice(indexOfOldAttachment, 1);
        this.attachments.data = newAttachmentList;
      }
      else if (type == 1) {
        let indexOfOldAttachment = newAttachmentList.findIndex(elem => elem.ID == x.ID);
        if (indexOfOldAttachment >= 0) {
          // splice and insert updated element
          newAttachmentList.splice(indexOfOldAttachment, 1,
            {
              FilePath: x.FilePath,
              Description: x.Description,
              FileName: x.FileName,
              IsImage: this.CheckIsImage(x),
              ID: x.ID,
              IsDirty: x.IsDirty,
              UploadedDate: x.CreateDate,
              ModifyDate: x.ModifyDate,
              WorkTicketNo: x.WorkTicketNo == null || x.WorkTicketNo == undefined ? "-" : x.WorkTicketNo,
              HasWorkOrderAttachments: x.WorkTicketNo != undefined && x.WorkTicketNo != null && x.WorkTicketNo != "",
              WorkTicketID: (x.WorkTicketID == null || x.WorkTicketID == undefined) ? "" : x.WorkTicketID,
              UploadedBy: x.CreatedByUser != undefined && x.CreatedByUser != null ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : ""
            }
          );
          this.attachments.data = newAttachmentList;
        }
      }
      else if (type == 0) {
        if (!CommonMethods.CheckNullOrUndefined(x.Data) && x.Data.length >= 1) {

          newAttachmentList = newAttachmentList.concat(x.Data.map(x => { // chaining map with concat to push elements
            return {
              FilePath: x.FilePath,
              Description: x.Description,
              FileName: x.FileName,
              IsImage: this.CheckIsImage(x),
              ID: x.ID,
              IsDirty: x.IsDirty,
              UploadedDate: x.CreateDate,
              ModifyDate: x.ModifyDate,
              WorkTicketNo: x.WorkTicketNo == null || x.WorkTicketNo == undefined ? "-" : x.WorkTicketNo,
              HasWorkOrderAttachments: x.WorkTicketNo != undefined && x.WorkTicketNo != null && x.WorkTicketNo != "",
              WorkTicketID: (x.WorkTicketID == null || x.WorkTicketID == undefined) ? "" : x.WorkTicketID,
              UploadedBy: x.CreatedByUser != undefined && x.CreatedByUser != null ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : ""
            }
          }));

          this.attachments.data = newAttachmentList;
        }

      }
    }
  }
  private GetJobSiteDocumentsAndImages(jobSiteAttachments: any) {
    if (jobSiteAttachments != null) {
      this.attachments.data = jobSiteAttachments.map(x => {
        return {
          FilePath: x.FilePath,
          Description: x.Description,
          FileName: x.FileName,
          IsImage: this.CheckIsImage(x),
          ID: x.ID,
          IsDirty: x.IsDirty,
          UploadedDate: x.CreateDate,
          ModifyDate: x.ModifyDate,
          WorkTicketNo: x.WorkTicketNo == null || x.WorkTicketNo == undefined ? "-" : x.WorkTicketNo,
          HasWorkOrderAttachments: x.WorkTicketNo != undefined && x.WorkTicketNo != null && x.WorkTicketNo != "",
          WorkTicketID: (x.WorkTicketID == null || x.WorkTicketID == undefined) ? "" : x.WorkTicketID,
          UploadedBy: x.CreatedByUser != undefined && x.CreatedByUser != null ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : ""
        }
      });
      this.attachments.total = this.attachments.data.length;
    }
  }

  private CheckIsImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        return this.commonMethods.ValidExtension(fileName, exts);
      }
      else
        return false;
    }
    else
      return false;
  }

  /** used for attachment slider */
  ViewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }

  /** used for attachment slider */
  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }

  private GetCustomerJobsites(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
    this.httpCustomerService.GetCustomerJobSites(this.detailData.ID, "").subscribe(
      response => {
        this.HideDataLoader();
        this.customerJobSites = (response != null) ? response.jobSites.sort((a, b) => (a.DisplayName > b.DisplayName) ? 1 : -1) : [];
        this.customerJobSitesOriginal = this.customerJobSites;
        this.jobSiteSelectorDummyValue.DisplayName = this.jobSiteSelectorDummyValue.ResetName + ` (${this.customerJobSitesOriginal.length})`;
        this.originalJobSite = this.customerJobSitesOriginal.find(x => x.ID == this.inputParams.jobsiteId);
        this.selectedJobSite = this.customerJobSitesOriginal.find(x => x.ID == this.inputParams.jobsiteId);
      }, error => {
        this.HideDataLoader();
      }
    );
  }

  private GetDetails(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
    this.httpCustomerService.GetJobSiteDetail(this.detailData.ID, this.inputParams.jobsiteId, "TaxGroup,Contacts,Attachments").subscribe(
      response => {
        this.HideDataLoader();
        if (response != null) {
          this.detailData = response.Customer; // update customer detail for new data
          response.Customer = null;
          this.detailData.JobSites = [response];
          this.jobSiteDetail = response;
          if (!CommonMethods.CheckNullOrUndefined(this.jobSiteDetail.Contacts, true))
            this.jobSitePrimaryContactInfo = this.jobSiteDetail.Contacts.find(x => x.Contact.IsPrimary).Contact;
          else
            this.jobSitePrimaryContactInfo = "";

          if (!CommonMethods.CheckNullOrUndefined(this.detailData.Contacts, true))
            this.primaryContactInfo = this.detailData.Contacts.find(x => x.Contact.IsPrimary == true).Contact;

          this.customerAddress = CommonMethods.GetCompleteAddress(this.detailData);
          this.jobSiteAddress = CommonMethods.GetCompleteAddress(this.jobSiteDetail);
        }
        //this.GetJobSiteDocumentsAndImages(response["Attachments"]);
      }
      , error => {
        this.HideDataLoader();
      }
    );
  }
  private GetJobSiteWorkOrders(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    let jobSiteID = this.inputParams.jobsiteId;
    this.showNoRecordworkorder = this.showspinner.showloader(this.workOrdersGridSectiongrid,this.tabCounter,instantSpinnerTime, true, this.workOrdersGridData.total);

    Object.assign(this.prev_state, this.state); // copy source to target,, Object.assign(target, source)
    this.state.take = this.state.take;
    this.state.skip = this.state.skip;
    this.triggerRefresh = this.searchKey.length > 2 ? true : (this.searchKey.length == 0) ? false : this.triggerRefresh;
    this.listGetSubscription = this.httpCustomerService.GetJobSiteWorkOrders(jobSiteID, this.state, this.searchKey).subscribe(
      response => {
        if (response != null) {
          this.workOrdersGridData.data = response.Data;
          this.workOrdersGridData.total = response.Count;
        }
        this.changeDetector.detectChanges();
      }, 
      (error) => { this.showNoRecordworkorder = this.showspinner.hideLoader(this.workOrdersGridSectiongrid, this.tabCounter); 
        this.changeDetector.detectChanges();
      }, () => {this.showNoRecordworkorder = this.showspinner.hideLoader(this.workOrdersGridSectiongrid, this.tabCounter);}
    );
  }
  private GetJobSiteAttachments(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    let jobSiteID = this.inputParams.jobsiteId;
    this.showNoRecord = this.showspinner.showloader(this.DocumentsDivgrid,this.tabCounter,instantSpinnerTime, true, this.attachments.total);
    Object.assign(this.prev_state, this.state); // copy source to target,, Object.assign(target, source)
    this.state.take = this.state.take;
    this.state.skip = this.state.skip;
    this.listGetSubscription = this.httpCustomerService.GetJobSiteAttachments(this.detailData.ID, jobSiteID, this.state, this.searchKey).subscribe(
      response => {
        this.showNoRecord = this.showspinner.hideLoader(this.DocumentsDivgrid, this.tabCounter);
        if (response != null) {
          this.GetJobSiteDocumentsAndImages(response["Data"]);
        }
        this.changeDetector.detectChanges();
      }, error => {
        this.showNoRecord = this.showspinner.hideLoader(this.DocumentsDivgrid, this.tabCounter);
        this.changeDetector.detectChanges();
      }
    );
  }

  private HideDataLoader() {
    this.dataLoaderCount = this.dataLoaderCount - 1;
    if (this.dataLoaderCount <= 0) {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    }
  }

  private IntializeFilters() {
    this.customFilterForm = this.frmbuilder.group({
      searchString: new FormControl("")
    });
  }

  /**
  * @remarks Method to manage jobsite attachments
  * @param type 0 - Create, 1 - Update, 2 - delete
  * @param attachmentId Attachment ID
  */
  private ManageJobSiteAttachments(type: number, updatedAttachment: any) {
    let newAttachmentList = Object.assign([], this.attachments.data);
    let req = [];
    if (type == 0) {
      let fileDescription = this.attachmentForm.controls["Description"].value;
      this.kendoUploadFileList.forEach(x => {
        x.attachmentInfo.Description = fileDescription;
        x.attachmentInfo.IsDirty = false;
        // newAttachmentList.push(x.attachmentInfo);       
        req.push(this.AttachmentMapper(x.attachmentInfo));
      });
    } else if (type == 2) { // (1)update and (2)delete
      let selectedAttachment = null;
      selectedAttachment = newAttachmentList.filter(x => x.ID == updatedAttachment.ID);
      req.push(this.AttachmentMapper(selectedAttachment[0]));
    }
    else if (type == 1) { // (1)update and (2)delete
      req.push(this.AttachmentMapper(updatedAttachment));
    }
    if (!CommonMethods.CheckNullOrUndefined(this.jobSiteDetail.ID) && req.length > 0) {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
        this.httpCustomerService.CreateUpdateDeleteJobSiteAttachment(this.detailData.ID, this.jobSiteDetail.ID, req, type).subscribe(response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.jobSiteDetail.ModifyDate = response.ModifyDate;
        this.updateJobSiteDocumentsAndImages(response, type, req);
        let msg = "";
        if (type == 0)
          msg = "Attachments Saved"
        else if (type == 1)
          msg = "Attachment Updated";
        else
          msg = "Attachment Deleted";
        this.toastr.success(msg, "Success");
      }, error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error");
      });
    }
  }

  private AttachmentMapper(selectedAttachment: any): JobSiteRequest.Attachment {
    let ExternalAttachment = new JobSiteRequest.ExternalAttachment2();
    let request = new JobSiteRequest.Attachment();
    request.ID = CommonMethods.GetID(selectedAttachment.ID);
    request.FilePath = selectedAttachment.FilePath;
    request.Description = selectedAttachment.Description;
    request.FileName = selectedAttachment.FileName;;
    request.IsDefaultImage = selectedAttachment.IsDefaultImage;
    request.IsDirty = selectedAttachment.IsDirty;
    request.ExternalAttachment2 = ExternalAttachment;
    return request;
  }

  private scroll = (event): void => {
    if (event.srcElement.id == 'mainContentSection') {
      let activeTabCounter = + $(".activeContent").attr("tabcounter");
      let modalId = "#modal_container_" + this.tabCounter;
      if (activeTabCounter == this.tabCounter) {
        if ($(modalId).length > 0) {
          this.commonMethods.SetModalHeightWhenScrolled(modalId, event.srcElement);
        }
      }
    }
  };
  //#endregion
  private resetState(){
    this.state.skip = 0;
    this.state.take = 25;
  }
}
